import { CheckCircle2 } from "lucide-react";
import Modal from "./Modal";

/**
 * Shared success state shown after a payment completes (card or bank transfer).
 */
function PaymentConfirmedModal({
  isOpen,
  onClose,
  onMessage,
  onDone,
  messageLabel = "Message host",
  isMessaging = false,
}) {
  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      panelClassName="max-w-md"
      showClose={false}
    >
      <div className="space-y-6 py-2 text-center">
        <div className="mx-auto flex h-20 w-20 items-center justify-center rounded-full bg-[#EAF6EE]">
          <CheckCircle2 className="h-10 w-10 text-[#2f8a4c]" strokeWidth={2.5} />
        </div>
        <div className="space-y-2">
          <h3 className="text-2xl font-bold text-[#570033]">
            Payment Confirmed
          </h3>
          <p className="text-sm text-slate-500">
            Your payment have been confirmed successfully
          </p>
        </div>

        <div className="space-y-3 pt-2">
          <button
            type="button"
            onClick={onMessage}
            disabled={isMessaging}
            className="w-full rounded-xl bg-[#570033] py-3 text-sm font-semibold text-white transition hover:bg-[#450029] disabled:cursor-not-allowed disabled:opacity-70"
          >
            {isMessaging ? "Opening chat..." : messageLabel}
          </button>
          <button
            type="button"
            onClick={onDone}
            className="w-full rounded-xl border border-[#570033] py-3 text-sm font-semibold text-[#570033] transition hover:bg-[#F8EEF4]"
          >
            Done
          </button>
        </div>
      </div>
    </Modal>
  );
}

export default PaymentConfirmedModal;
